<template>
  <bar-chart
    :height="height"
    :chart-data="chartConfig"
  />
</template>

<script>
import BarChart from "@/components/Charts/BarChart";

export default {
  name: 'AvaliationSelectChart',
  components: { BarChart },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    avaliationItem: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 250,
    },
  },
  computed: {
    options() {
      if (!this.avaliationItem || !this.avaliationItem.config) return [];
      return this.avaliationItem.config.options || [];
    },
    chartConfig() {
      if (!this.chartData || !this.chartData.data) return {};

      const values = this.options.map((label) => this.chartData.data[label.toUpperCase()] || 0);

      return {
        labels: this.options,
        datasets: [
          {
            label: 'Respostas',
            backgroundColor: '#2dce8a',
            data: values,
          },
        ],
      };
    },
  }
}
</script>
